document.addEventListener("DOMContentLoaded", function() {
  var burger = document.querySelector('.gh-burger');
  var menu = document.querySelector('.gh-navigation-menu');

  burger.addEventListener('click', function() {
      menu.classList.toggle('active');
  });
});
